import {
  DynamicField,
  DynamicForm,
  FieldVariant,
  SelectFieldProps,
  SelectOption,
  TextFieldProps,
} from '@/components/form-builder/form-builder.types';
import { ApprovalTypeRepository } from '@/store/approval-type-state/approval-type-state.repository';

interface IApprovalTypeFormObjectProps {
  store: ApprovalTypeRepository;
  approvalTypeCategoriesOptions: { label: string; value: number }[];
}

export const getApprovalTypeFormObject = ({ store, approvalTypeCategoriesOptions }: IApprovalTypeFormObjectProps): DynamicForm => {
  const libelleField: DynamicField<TextFieldProps> = {
    label: 'settings.approvalType.form.libelle.label',
    variant: FieldVariant.TEXT,
    isRequired: true,
    error: store.getNestedObservable<string>('errors', 'libelle'),
    props: {
      value: store.getNestedObservable<string>('dto', 'libelle'),
      onChange: (value: string) => {
        store.setNestedWithComparison('dto', 'libelle', value);
        store.setNested('errors', 'libelle', '');
      },
    },
  };

  const approvalTypeTypeField: DynamicField<SelectFieldProps> = {
    label: 'settings.approvalType.form.organismeDeDeliveranceAgrements.label',
    variant: FieldVariant.SELECT,
    isRequired: true,
    error: store.getNestedObservable<string>('errors', 'organismeDeDeliveranceAgrementsId'),
    props: {
      placeholder: 'settings.approvalType.form.organismeDeDeliveranceAgrements.placeholder',
      options: approvalTypeCategoriesOptions?.map(cat => {
        return { name: cat.label, code: cat.value };
      }),
      value: store.getObservable('approvalTypeSelected'),
      onSelectChange: (value: SelectOption) => {
        store.setNestedWithComparison('dto', 'organismeDeDeliveranceAgrementsId', value.code);
        store.setWithComparison('approvalTypeSelected', value);
        store.setNested('errors', 'organismeDeDeliveranceAgrementsId', '');
      },
    },
  };

  return {
    title: 'settings.approvalType.form.title',
    description: '',
    isHeaderHidden: true,
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [libelleField],
          },
          {
            fields: [approvalTypeTypeField],
          },
        ],
      },
    ],
  };
};
